import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
const i18nMixin = {
  created: function () {
    // this.buildSysParam()
  },
  computed: {
    i18nValues: get("i18nStore/valuesRetrieved"),
  },
  data() {
    return {

    }
  },
  methods: {

  },
};
export default i18nMixin